define('blocks/burger/burger',['require'],function(require) {
    var $burgerMenu = $('.burger-menu');

    $burgerMenu.on('click', '.burger-menu__burger', function() {
        $burgerMenu.toggleClass('open');
    });
    $burgerMenu.on('click', '.burger-menu__menu', function() {
        $burgerMenu.removeClass('open');
    });
})
;
